import React from 'react';
import Page from '../../layout/Page';
import KioskItems from '../settings/KioskItems';

const KioskItemsPage = () => (
    <Page title='Kiosk Items' icon='coins'>
        <KioskItems />
    </Page>
);

export default KioskItemsPage;
